import React, {useState, useContext} from 'react'
import styled from 'styled-components'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MoreIcon from '@material-ui/icons/MoreVert';
import MainMenu from './MainMenu';
import ConnectionWidget from './ConnectionWidget';
import {MainContext} from '../../App';
import history from '../../history';
import { logoffFn } from '../../Helpers/auth';
// import Logo from './Logo';
import LogoFrente from './LogoFrente';


const SectionDesktop = styled.div`
  display: none;
  @media (min-width: 600px) {
    display: flex;
  }
`
const SectionMobile = styled.div`
  display: none;
  @media (max-width: 599px) {
    display: flex;
  }
`
const B = ({children, ...props}) => props.badgeContent ? (
  <Badge {...props}>{children}</Badge>
) : (
  <span {...props}>{children}</span>
)


function TopBar (props) {

  const [anchorEl_desktop, setAnchorEl_desktop] = React.useState(null);
  const [anchorEl_mobile, setAnchorEl_mobile] = React.useState(null);

  const openMenu_desktop = event => {
    setAnchorEl_desktop(event.currentTarget);
  };
  const openMenu_mobile = event => {
    setAnchorEl_mobile(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl_desktop(null);
    setAnchorEl_mobile(null);
  };

  const [ estado, setEstado ] = useState(false);
  const { user, setUser } = useContext(MainContext);
  return (
    <>
    <div>
      <AppBar position="fixed">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={()=>setEstado(true)}
            style={{
              marginLeft: -12,
              marginRight: 20,
            }}
          >
            <MenuIcon />
          </IconButton>
          <LogoFrente />
          {/* <Typography variant="title" color="inherit" noWrap>
            Wilson Contabilidade
          </Typography> */}
          {/* <div style={{flexGrow: 1}} /> */}
          <SectionDesktop>
            <IconButton color="inherit">
              <ConnectionWidget />
            </IconButton>
            <IconButton color="inherit">
              <B badgeContent={0} color="secondary">
                <MailIcon />
              </B>
            </IconButton>
            <IconButton color="inherit">
              <B badgeContent={0} color="secondary">
                <NotificationsIcon />
              </B>
            </IconButton>
            <IconButton
              aria-owns={Boolean(anchorEl_desktop) ? 'material-appbar' : null}
              aria-haspopup="true"
              onClick={e => user ? setAnchorEl_desktop(e.currentTarget) : history.push("/logon")}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </SectionDesktop>
          <SectionMobile>
            <IconButton
              aria-haspopup="true"
              onClick={openMenu_mobile}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </SectionMobile>
        </Toolbar>
      </AppBar>
      { user && 
        <DesktopMenu 
          handleClose={handleClose}
          anchorEl={anchorEl_desktop}
          user={user}
          setUser={setUser}
        />
      }
      <MobileMenu
        handleClose={handleClose}
        anchorEl={anchorEl_mobile}
      />
    </div>
    <MainMenu estado={estado} setEstado={setEstado} />
    </>
  );
}

function DesktopMenu (props) {
  const { user, setUser, anchorEl, handleClose } = props;
  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
      <MenuItem onClick={()=>null}>{user.alias}</MenuItem>
      <MenuItem onClick={()=>{
        history.push("/usuarios/minha-conta")
        handleClose()
      }}>
        Minha conta
      </MenuItem>
      <MenuItem onClick={()=>{
        if (window.confirm("Tem certeza que deseja sair?")) {
          logoffFn().then(r => {
            handleClose()
            setUser()
            history.push("/")
          })
        }
      }}>Logoff</MenuItem>
    </Menu>
  )
}

function MobileMenu (props) {
  const { user, setUser, anchorEl, handleClose } = props;
  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
      <MenuItem>
        <IconButton color="inherit">
          <B badgeContent={0} color="secondary">
            <MailIcon />
          </B>
        </IconButton>
        <p>Mensagens</p>
      </MenuItem>
      <MenuItem>
        <IconButton color="inherit">
          <B badgeContent={0} color="secondary">
            <NotificationsIcon />
          </B>
        </IconButton>
        <p>Notificações</p>
      </MenuItem>
      <MenuItem onClick={e=>null}>
        <IconButton color="inherit">
          <AccountCircle />
        </IconButton>
        <p>Perfil</p>
      </MenuItem>
    </Menu>
  );
}


export default TopBar;
